"use client";

import { fetchItemsByTopic } from "@/actions/fetchItemsByTopic";
import { useRouter } from "next/navigation";
import { useRef, useState, useTransition } from "react";
import EditorialContentCard from "../editorials/EditorialElements/EditorialContentCard";

export function TopicGridBySlug({
  initialItems,
  initialPage = 1,
  language,
  topic,
}: {
  initialItems: any[];
  initialPage?: number;
  language: string;
  topic: string;
}) {
  const [items, setItems] = useState<any[]>(initialItems);
  const [currentPage, setCurrentPage] = useState<number>(initialPage);
  const [isLoading, startLoading] = useTransition();
  const gridRef = useRef<HTMLUListElement | null>(null);
  const router = useRouter();

  const loadMoreItems = () => {
    const nextPage = currentPage + 1;
    startLoading(async () => {
      try {
        const newItems = await fetchItemsByTopic({
          language: language,
          topic: topic,
          page: nextPage,
          size: 21,
        });
        setItems(newItems.items);
        setCurrentPage(nextPage);
        router.push(`?page=${nextPage}`);
        gridRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
      } catch (error) {
        console.error(error);
      }
    });
  };
  

  return (
    <>
      {items?.map((item: any, index: number) => (
        <div key={item.id} className="topic__grid__item">
          <EditorialContentCard
            variant='grid'
            content={item}
            layout={{
              orientation: 'vertical',
              showImage: true,
              showTag: false,
              showLead: true,
            }}
          />
        </div>
      ))}

      {((currentPage === 1 && items.length > 17) || (items.length >= 21)) && <div style={{ display: "flex", placeItems: "center" }}>
        <div className="video-gallery__load-more">
          <button
            className="video-gallery__load-more-button"
            onClick={loadMoreItems}
            disabled={isLoading}
          >
            {isLoading ? language === "farsi" ? "در حال بارگذاری..." : "Loading More ..." : language === "farsi" ? "بارگذاری بیشتر" : "Load More"}
          </button>
        </div>
      </div>}
    </>
  );
}